<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 19.06"
  >
    <path
      class="cls-1"
      d="M47.85,7.79c-.36-.75-1.25-1.07-2-.71l-1.77.84C43.32,3.43,39.42,0,34.71,0h0c-4.41,0-8.11,3.01-9.2,7.08-.98-.26-2.01-.24-2.97.05C21.47,3.03,17.76,0,13.33,0h0C8.62,0,4.72,3.42,3.94,7.91l-1.86-.79c-.76-.32-1.64.03-1.97.8s.03,1.64.8,1.97l2.96,1.25s.04.01.06.02c.77,4.48,4.67,7.9,9.38,7.9,5.09,0,9.23-3.99,9.5-9.02.74-.38,1.61-.4,2.37-.09.22,5.07,4.39,9.11,9.51,9.11,4.68,0,8.56-3.38,9.37-7.82.05-.02.11-.03.16-.06l2.91-1.38c.75-.36,1.07-1.25.71-2ZM13.32,16.2c-3.69,0-6.68-2.99-6.68-6.68,0-3.69,2.99-6.67,6.68-6.68,3.69,0,6.68,2.99,6.68,6.68s-2.99,6.68-6.68,6.68ZM34.7,16.2c-3.69,0-6.68-2.99-6.68-6.68,0-.24.01-.48.04-.71l.14-.09s-.07-.07-.11-.11c.45-3.26,3.23-5.77,6.61-5.77,3.69,0,6.68,2.99,6.68,6.68s-2.99,6.68-6.68,6.68Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
